import useScreenSize from "../hooks/useScreenSize";

export default function LocationSection() {
  const { isMobile, isTablet } = useScreenSize();

  const nearbyPlaces = [
    {
      name: "Manyata Tech Park",
      distance: "20 mins",
    },
    {
      name: "Sparsh Hospital",
      distance: "8 mins",
    },
    {
      name: "Mall of Asia",
      distance: "15 mins",
    },
    {
      name: "Majestic Metro Station",
      distance: "30 mins",
    },
  ];

  return (
    <section
      style={{
        background: "#F5F2EB",
        padding: isMobile ? "80px 20px" : "120px 32px",
      }}
    >
      <div
        style={{
          maxWidth: 1300,
          margin: "0 auto",
          display: "flex",
          flexDirection: isTablet ? "column" : "row",
          alignItems: "center",
          gap: isTablet ? 50 : 70,
        }}
      >
        {/* Google Maps */}

        <div
          style={{
            width: isTablet ? "100%" : "58%",
            border: "1px solid #DDD7CC",
            overflow: "hidden",
          }}
        >
          <iframe
            title="Ebenezer Serviced Apartments"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.614563575661!2d77.64570837515846!3d13.060188487263352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae19fec86ea6cd%3A0xea4a455ecc409995!2sEbenezer%20Serviced%20Apartments%20and%20Suites!5e0!3m2!1sen!2sin!4v1784195169787!5m2!1sen!2sin"
            width="100%"
            height={isMobile ? "350" : "520"}
            style={{
              border: 0,
              display: "block",
            }}
            loading="lazy"
          />
        </div>


        {/* Content */}

        <div
          style={{
            width: isTablet ? "100%" : "42%",
            textAlign: isTablet ? "center" : "left",
          }}
        >
          <p
            style={{
              color: "#C9A66B",
              letterSpacing: ".16em",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: isMobile ? 12 : 14,
            }}
          >
            PRIME LOCATION
          </p>

          <h2
            style={{
              fontFamily: "'Fraunces', serif",
              fontSize: isMobile ? 36 : isTablet ? 42 : 48,
              color: "#222",
              lineHeight: 1.15,
              margin: "18px 0 28px",
            }}
          >
            Stay close to
            <br />
            everything that
            <br />
            matters.
          </h2>

          <p
            style={{
              color: "#666",
              lineHeight: 1.8,
              marginBottom: 40,
              fontSize: isMobile ? 16 : 18,
              maxWidth: isTablet ? 700 : "100%",
              marginInline: isTablet ? "auto" : 0,
            }}
          >
            Conveniently located in Whitefield, Ebenezer Serviced
            Apartments places you near major IT parks, hospitals,
            shopping destinations and public transport, making
            every journey effortless.
          </p>

          <div
            style={{
              display: "grid",
              gap: 18,
              maxWidth: isTablet ? 500 : "100%",
              margin: isTablet ? "0 auto" : 0,
            }}
          >
            {nearbyPlaces.map((place) => (
              <div
                key={place.name}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingBottom: 16,
                  borderBottom: "1px solid #DDD7CC",
                }}
              >
                <span
                  style={{
                    color: "#444",
                    fontSize: isMobile ? 16 : 17,
                  }}
                >
                  {place.name}
                </span>

                <span
                  style={{
                    color: "#C9A66B",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {place.distance}
                </span>
              </div>
            ))}
          </div>

          <a
            href="https://maps.google.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              marginTop: 40,
              padding: "16px 34px",
              background: "#222",
              color: "#FFF",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Get Directions
          </a>
        </div>
      </div>
    </section>
  );
}